import {
  DetailSectionWrapper,
  LocationFormFields,
  LocationSectionWrapper,
  QuestionLayout,
} from '@exam-management/qcontent-management';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import {
  DetailsFormSection,
  InformationFormSection,
  PropertiesFormSection,
  QuestionCreationHeader,
  SectionWrapper,
  SingleQuestionCreationFormActions,
  useGetQBSLevelAndLevelItemsForTask,
} from '@exam-management/question-creation-task-question-management';
import { Box, Flex, Loading, PaperSection, SectionTitle } from '@shared/components';

import { SingleQuestionCreationForm } from '../single-question-creation-form/';

export default function QuestionCreationTaskQuestionCreation() {
  const { task } = useQuestionCreationTaskDetails();
  const qBankStructureId = task.metadata?.requirement.qBankStructure?.id ?? '';

  const {
    qbsLevelItems,
    qbsLevels,
    loading: isGettingQBSLevel,
  } = useGetQBSLevelAndLevelItemsForTask(qBankStructureId, task.id);

  if (isGettingQBSLevel) return <Loading sx={{ height: '100%' }} />;

  return (
    <SingleQuestionCreationForm qbsLevels={qbsLevels}>
      <Box>
        <QuestionCreationHeader />
        <QuestionLayout
          sideContent={
            <PaperSection title='Location'>
              <LocationSectionWrapper>
                <LocationFormFields
                  prefix='location'
                  qbsLevels={qbsLevels}
                  qbsLevelItems={qbsLevelItems}
                />
              </LocationSectionWrapper>
            </PaperSection>
          }
        >
          <Flex sx={{ width: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
            <PaperSection title='Question Details'>
              <DetailSectionWrapper>
                <SectionWrapper>
                  <SectionTitle title='Information' />
                  <InformationFormSection />
                </SectionWrapper>
                <SectionWrapper>
                  <SectionTitle title='Question' />
                  <DetailsFormSection taskId={task.id} />
                </SectionWrapper>
                <SectionWrapper>
                  <SectionTitle title='Properties' />
                  <PropertiesFormSection taskId={task.id} />
                </SectionWrapper>
              </DetailSectionWrapper>
            </PaperSection>
            <SingleQuestionCreationFormActions />
          </Flex>
        </QuestionLayout>
      </Box>
    </SingleQuestionCreationForm>
  );
}
